import React, { PureComponent } from 'react';
import html2canvas from 'html2canvas';
import {
  getChoices,
  getDetail,
} from '../../api/subjectChoice';
import Loading from '../../components/Loading';
import dateFormatter from '../../utils/dateFormatter';
import './Welcome.less';
import {setDocTitle} from "../../utils/tools";
const cancle = require('../../assets/svg/menucancle_icon.svg');

class Welcome extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      choices: [],
      lastChoice: null,
      imgUrl: '',
      showReportModal: false,
      isMobile: null,
      loading: false
    }
  }

  componentDidMount() {
    const host = window.location.host;
    if(host==='xs.shijieu.cn'){
      setDocTitle('试界云学生端');
    }
    else if(host==='xs.t.shijieu.cn'){
      setDocTitle('试界云学生端-测试版');
    }
    else {
      setDocTitle('试界云测试端');
    }
    getChoices().then(({ data }) => {
      if (Array.isArray(data) && data.length) {
        this.setState({
          choices: data,
          lastChoice: data[0],
        });
      } else {
        const { history } = this.props;
        history.replace(`./start`);
      }
    });
    // 测试环境同时请求连个接口会有问题需要之后解决下 这是野路子解决；
    if (process.env.NODE_ENV === 'production') {
      getDetail().then(({data}) => {
        localStorage.setItem('user_detail', JSON.stringify(data));
      });
    }
    // document.getElementById['cb-report'].style.width = '80%';
    this.judgeIsMobile();
    window.onresize = () => {
      this.judgeIsMobile()
    }
  }
  judgeIsMobile() {
      try {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          this.setState({
            isMobile: true
          })
        } else {
          this.setState({
            isMobile: false
          })
        }
      } catch (e) {}

  }
  handleStart() {
    const { history } = this.props;
    history.push(`./start`);
  }
  handleClickPrintReport() {
    this.setState({loading: true});
    html2canvas(this.refs['cb-report']).then((canvas) => {
      var imgData = canvas.toDataURL('image/jpg');
      this.setState({
        showReportModal: true,
        imgUrl: imgData,
        loading: false
      });
    });
  }
  handleSaveImg() {
    let imgData = this.state.imgUrl;
    this.downloadFile('选课结果填报回执单.png', imgData);
  }
  //下载
  downloadFile(fileName, content) {
    let aLink = document.createElement('a');
    let blob = this.base64ToBlob(content); //new Blob([content]);

    let evt = document.createEvent("HTMLEvents");
    evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = fileName;
    aLink.href = URL.createObjectURL(blob);

    // aLink.dispatchEvent(evt);
    //aLink.click()
    aLink.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })); //兼容火狐
  }
  //base64转blob
  base64ToBlob(code) {
    let parts = code.split(';base64,');
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;

    let uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {
      type: contentType
    });
  }
  handleClickModelBg(e) {
    // console.log(e)
  }
  render() {
    const {
      lastChoice,
      choices,
      imgUrl,
      showReportModal,
      isMobile,
      loading
    } = this.state;
    let user_detail = {};
    if (localStorage.getItem('user_detail')) {
      user_detail = JSON.parse(localStorage.getItem('user_detail'));
    }
    return lastChoice === null ? "" : (
      <div className="subject-choice-wrapper">
        <div className="subject-choice-inner">
          <h1><span>欢迎进入</span><br />新高考选科填报系统</h1>
          <div className="last-choice">
            <p>你最近一次选科决策是</p>
            <div className="chosen-subjects">
              {lastChoice.subjects.map(d => (
                <div key={d.id} className="subject">{d.name}</div>
              ))}
            </div>
            <p className="choice-time">{dateFormatter(lastChoice.created)}</p>
          </div>
          <div className="btn-wrapper">
              <div className="btn" onClick={this.handleClickPrintReport.bind(this)}>
                打印填报回执单
              </div>
          </div>
          <div className="choice-history">
            <p>你的填报历史</p>
            <ul>
              {choices.map((d, i) => (
                <li key={i}>
                  <div className="subjects">
                    {d.subjects.map(d => (
                      <span key={d.id} className="subject">{d.name}</span>
                    ))}
                  </div>
                  <span className="choice-time">{dateFormatter(d.created)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="subject-choice-bottom">
          <button className="primary full" onClick={this.handleStart.bind(this)}>填写新的选科决策</button>
        </div>
        {
          showReportModal &&
          <div className="cb-report-model-wrapper" onClick={this.handleClickModelBg.bind(this)}>
            <div className="cb-report-model">
                <div className="model-title">
                  回执单预览图
                </div>
                <div className="img-wrapper">
                  <img src={imgUrl} alt="回执单" />
                </div>
                <div className="guide-tip">
                  <div className="operate-way">
                    <span className="letter">{isMobile ? '确认填报信息无误后，请长按上图保存图片' : '确认填报信息无误后，点击保存图片'}</span>
                    <div className="line"></div>
                  </div>
                  <div className="give-teacher">
                    可在将回执单打印出来后， 签好学生和家长的姓名上交给老师
                  </div>
                  {
                    !isMobile &&
                    <div className="operate-btn-group">
                      <div className="btn btn-cancel" onClick={() => {this.setState({showReportModal: false})}}>取消</div>
                      <div className="btn btn-save" onClick={this.handleSaveImg.bind(this)}>保存图片</div>
                    </div>
                  }
                </div>
                {isMobile && <img className="close-icon" onClick={() => {this.setState({showReportModal: false})}} src={cancle} alt="关闭图标"/>}
            </div>
          </div>
        }
        {
          loading && <Loading />
        }
        <div ref="cb-report"
             className="cb-report"
             id="cb-report">
          <div className="title">选科填报结果回执单</div>
          <div className="personal-info">
            <div className='info'>
              姓名：{user_detail.student.realName}
            </div>
            <div className='info'>
              年级：{user_detail.student.gradeYear}
            </div>
            <div className='info'>
              班级：{!!user_detail.student.classId && `${user_detail.student.classId}班`}
            </div>
            <div className='info'>
              学号：{user_detail.student.schoolStuNum}
            </div>
          </div>
          <div className="personal-result">
            <div className="personal-title">填报结果</div>
            <div className="chosen-subjects">
              {lastChoice.subjects.map(d => (
                <div key={d.id} className="subject">{d.name}</div>
              ))}
            </div>
          </div>
          <div className="signature">
                <span className="student">学生签字：</span>
                <span className="teacher">家长签字：</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/pages/SubjectChoice/Welcome.js